import { useQuery, QueryConfig, useQueryCache } from "react-query";
import * as React from "react";
import { buildBrandCacheKeys } from "./utils";
import { IBrand } from "./../types/brands";
import { brand } from "../services/brands";

const fetchBrands = () =>
    brand.fetchBrandsForAssortment().then((responseJson) => {
        return responseJson.filter((brandEntity) => brandEntity.modules?.assortments?.enabled);
    });

export const useFetchBrandsForAssortment = (options?: QueryConfig<IBrand[]>) => {
    return useQuery<IBrand[]>(buildBrandCacheKeys(), fetchBrands, options);
};

export const usePrefetchBrandsForAssortment = (shouldPrefetch: boolean = true) => {
    const cache = useQueryCache();
    React.useEffect(() => {
        if (shouldPrefetch) {
            cache.prefetchQuery(buildBrandCacheKeys(), fetchBrands);
        }
    }, [shouldPrefetch, cache]);
};

export const useFetchBrandForMerchant = (
    merchantId: string,
    isExternalCall?: boolean,
    options?: QueryConfig<IBrand>
) => {
    return useQuery<any>(
        buildBrandCacheKeys(merchantId, isExternalCall),
        () => brand.fetchBrandForMerchant(merchantId),
        options
    );
};
